import { useState } from "react";
import logo from "../assets/bondz_logo.png"
import triangle from "../assets/triangle.png"

import { AnimatePresence, motion, useAnimationFrame, useMotionValue } from "framer-motion";

export default function Header(props) {

    const lang = props.lang
    const setLang = props.setLang

    const [showLanguages, setShowLanguages] = useState(false);

    return (
        <div className="header"
            
        >
            <img src={logo}></img>
        </div>
    );
}